import React from 'react'
import SuccessImage from "../../../assets/images/success.png"
import { Image, Typography, Card, Row, Col, Flex } from 'antd'
import { VerticalSteps } from '../../../components/CustomSteps/Steps';
import { useLocation } from 'react-router-dom';
import { formatCurrency, formatDateShort } from '../../../helpers/helpers';

const { Title, Text } = Typography;

const SuccessfulDealBuy = () => {
    const location = useLocation()
    const { dealInfo, txnId } = location.state
    const isJointVenturesDeal = Boolean(dealInfo?.isJointVenturesDeal);

    const today = new Date();
    const formattedTodayDate = today.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });

    return (
        <div className='success-container'>
            <Image src={SuccessImage} alt='Success' preview={false} style={{ marginBottom: 20 }} />
            <Title level={5}>Congratulations</Title>
            <Text style={{ fontSize: 14, marginBottom: 10, color: "#40566D" }}>
                Thanks for making us a part of your investment journey, We will email you the transaction details
            </Text>
            <Text style={{ fontSize: 14, color: "#40566D" }}>
                Transaction ID: {txnId ? txnId : ""}
            </Text>
            <Card className='success-deal-details-card'>
                <Row>
                    <Col xs={24} lg={12}>
                        <Text style={{ fontWeight: 500 }}><Text strong>Enterprise Name: </Text>{dealInfo?.entName}</Text>
                        <Row gutter={[16, 32]} style={{ marginTop: 30 }}>
                            <Col xs={24} md={12} lg={8}>
                                <div className='detail'>
                                    <Typography style={{ fontSize: 12, color: "#40566D" }}>Deal ID</Typography>
                                    <Typography style={{ fontWeight: 600, color: "#101924" }}>{dealInfo?.dealId}</Typography>
                                </div>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <div className='detail'>
                                    <Typography style={{ fontSize: 12, color: "#40566D" }}>Deal Value</Typography>
                                    <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(Number(dealInfo?.dealValue))}</Typography>
                                </div>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <div className='detail'>
                                    <Typography style={{ fontSize: 12, color: "#40566D" }}>Maturity</Typography>
                                    <Typography style={{ fontWeight: 600, color: "#101924" }}>{dealInfo?.maturity} days</Typography>
                                </div>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <div className='detail'>
                                    <Typography style={{ fontSize: 12, color: "#40566D" }}>Expected Gross Profit</Typography>
                                    <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.expectedGrossProfit)}</Typography>
                                </div>
                            </Col>
                            {!isJointVenturesDeal ? (
                              <Col xs={24} md={12} lg={8}>
                                  <div className='detail'>
                                      <Typography style={{ fontSize: 12, color: "#40566D" }}>Platform Fee</Typography>
                                      <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.platformFee)}</Typography>
                                  </div>
                              </Col>
                            ) : null}
                            {!isJointVenturesDeal ? (
                              <Col xs={24} md={12} lg={8}>
                                  <div className='detail'>
                                      <Typography style={{ fontSize: 12, color: "#40566D" }}>Expected Net Yield</Typography>
                                      <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.expectedNetYield)}</Typography>
                                  </div>
                              </Col>
                            ) : null}
                            <Col xs={24} md={12} lg={8}>
                                <div className='detail'>
                                    <Typography style={{ fontSize: 12, color: "#40566D" }}>Total Payout</Typography>
                                    <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.expectedNetRepayment)}</Typography>
                                </div>
                            </Col>
                            <Col xs={24} md={12} lg={8}>
                                <div className='detail'>
                                    <Typography style={{ fontSize: 12, color: "#40566D" }}>Amount to pay now</Typography>
                                    <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.amountToPayNow)}</Typography>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} lg={2} className='divider-container'>
                        <div className="divider" />
                    </Col>
                    <Col xs={24} lg={10}>
                        <Flex vertical gap="small">
                            <Text strong>ORDER STATUS</Text>
                            <Text style={{ color: "#40566D", marginBottom: 20 }}>You can track this order from Orders Tab</Text>
                            <VerticalSteps dealBookedDate={formattedTodayDate} repaymentDate={formatDateShort(dealInfo?.repaymentOn)} />
                        </Flex>
                    </Col>
                </Row>
            </Card>
            <Text className='note-text'>
                <span style={{ fontWeight: "bold" }}>Note: </span>The numbers and calculations provided are based on the expected maturity date of the invoices.
                Actual results may vary due to changes in market conditions, payment schedules, or other unforeseen factors.
                Please review all terms and conditions carefully and consult with a financial advisor if you have any questions or concerns.
            </Text>
        </div>
    )
}

export default SuccessfulDealBuy